export class Login {
  constructor(public email: string, public password: string, public rest_api:boolean = true){
  }
}

